import {
  datadogRum,
  type RumEvent,
  type RumEventDomainContext,
} from '@datadog/browser-rum';
import { useAccountContext } from '@seek/hirer-graphql-react';
import { useEffect } from 'react';

import { Environment } from 'src/types';

interface Props {
  children: JSX.Element;
  env: Environment;
  version: string;
}

const ignoredErrors = new Set([
  // Logged by Online Identity SDK and is not really an error
  'Error: Login required',
  // Logged by Online Identity SDK and we don't really care about impersonation
  'Error: impersonation_failed_unauthorized_seek_network_required',
]);

const filterNoise = (
  event: RumEvent,
  _context: RumEventDomainContext,
): boolean => {
  if (event.type === 'error' && ignoredErrors.has(event.error.message)) {
    return false;
  }

  return true;
};

export const DatadogProvider = ({ children, env, version }: Props) => {
  const { accountContext } = useAccountContext();

  useEffect(() => {
    if (env === Environment.PROD) {
      datadogRum.init({
        applicationId: '28cb4cfb-8b3c-418c-910e-f01041522198',
        clientToken: 'pub00c77986cfcfdfd95af89a44ea8bef6a',
        site: 'datadoghq.com',
        service: 'partner-hub',
        version,
        env,
        sessionSampleRate: 100,
        silentMultipleInit: true,
        beforeSend: filterNoise,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask',
      });
    }
  }, [env, version]);

  useEffect(() => {
    if (env === Environment.PROD) {
      datadogRum.setUser({
        id: accountContext?.currentUser?.id,
        hirerId: accountContext?.currentAdvertiser?.seekId,
      });
    }
  }, [env, accountContext]);

  return <>{children}</>;
};
